import * as React from "react";
import { Prompt } from "react-router";
import i18n from "Translations/i18n";

interface IProps {
    confirmToLeave: boolean;
}

interface IState {
}

class ConfirmToLeave extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }

    public componentDidUpdate = () => {
        window.onbeforeunload = this.props.confirmToLeave ? () => this.props.confirmToLeave : null;
    }

    public componentWillUnmount() {
        window.onbeforeunload = null;
    }

    public handleLeave(location: any) {
        window.onbeforeunload = null;
        window.setTimeout(() => {
            window.onbeforeunload = () => this.props.confirmToLeave;
        });
        return i18n.t("common.confirmLeaveWithoutSave").replace("{location}", location.pathname);
    }

    public render() {
        return (
            <Prompt
                when={this.props.confirmToLeave}
                message={location => this.handleLeave(location)}
            />
        );
    }
}

export default ConfirmToLeave;


// WEBPACK FOOTER //
// ./src/Components/Common/ConfirmToLeave/ConfirmToLeave.tsx